
import React, { useState, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import ProductTabs from '@/components/home/NewArrivals';
import HeroCarousel from '@/components/home/HeroCarousel';
import { useIsMobile } from '@/hooks/use-mobile';
import { useProducts } from '@/hooks/useProducts';
import { toast } from 'sonner';

const Index: React.FC = () => {
  const isMobile = useIsMobile();
  const { products, isLoading, error } = useProducts();
  const [newArrivals, setNewArrivals] = useState<any[]>([]);
  const [hotDeals, setHotDeals] = useState<any[]>([]);
  
  // Process products when data is loaded
  useEffect(() => {
    if (products.length) {
      // Convert Firestore products to the format expected by our components
      const formattedProducts = products.map(product => ({
        id: product.id,
        name: product.name,
        price: product.price,
        currency: 'RWF',
        image: product.imageUrl,
        description: product.description,
        discount: product.discount,
        couponCode: product.couponCode
      }));
      
      // Sort products by most recent (if createdAt exists)
      const sortedByDate = [...formattedProducts].sort((a, b) => {
        // Safety check in case products don't have createdAt
        const dateA = products.find(p => p.id === a.id)?.createdAt || new Date();
        const dateB = products.find(p => p.id === b.id)?.createdAt || new Date();
        return dateB.getTime() - dateA.getTime();
      });
      
      // Get products with discounts or coupons for hot deals
      const productsWithDeals = formattedProducts.filter(
        product => (product.discount && product.discount > 0) || product.couponCode
      );
      
      // Use the newest 10 products as new arrivals
      setNewArrivals(sortedByDate.slice(0, 10));
      
      // Use products with discounts or coupons as hot deals
      setHotDeals(productsWithDeals.slice(0, 10));
    }
  }, [products]);
  
  // Show error if products failed to load
  useEffect(() => {
    if (error) {
      toast.error("Failed to load products. Please try again later.");
      console.error("Product loading error:", error);
    }
  }, [error]);
  
  return (
    <Layout>
      <div className="w-full max-w-[100vw] overflow-hidden">
        {/* Hero Carousel */}
        <div className="w-full overflow-hidden">
          <HeroCarousel />
        </div>
        
        {/* Products Tabs section */}
        <div className="pt-6 md:pt-8 w-full overflow-hidden">
          {isLoading ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-pulse text-center">
                <div className="h-8 w-40 bg-gray-200 rounded mb-4 mx-auto"></div>
                <div className="h-4 w-60 bg-gray-200 rounded mx-auto"></div>
              </div>
            </div>
          ) : (
            <ProductTabs 
              newArrivals={newArrivals} 
              hotDeals={hotDeals} 
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Index;
